const VERSION = '2.0.18b'
export default VERSION
